import { computed } from 'mobx';
import FileModel    from './globals/FileModel';

export default class DemandLogisticMediaModel extends FileModel {
  static get path() {
    return '/backend/demand_logistic_media/{?id}';
  }

  @computed
  get type() {
    return this.get('type');
  }

  @computed
  get objectUrl() {
    return this.get('objectUrl');
  }

  @computed
  get mediaFileName() {
    return this.get('mediaFileName');
  }
}
